// extracted by mini-css-extract-plugin
export default {"panel":"AddVideo_panel__G1Uz5","panel_body":"AddVideo_panel_body__ks9Sb","uploader_section":"AddVideo_uploader_section__Zvzdr","radio":"AddVideo_radio__km-OK"};